import { formatTableDate, formatTableDateTime } from '@/shared/utils/app-timezone';
export const AIRPLANE_TICKET_STATUS_TABS = [
    'PENDING',
    'OFFERED',
    'CUSTOMER_APPROVED',
    'INVOICE_UPLOADED',
    'INVOICE_APPROVED',
    'INITIATED_RESCHEDULE',
    'RESCHEDULE_REQUESTED',
    'CANCELING_INITIATED',
];
export const AIRPLANE_TICKET_TAB_LABELS = {
    PENDING: 'New Requests',
    OFFERED: 'Offers Sent',
    CUSTOMER_APPROVED: 'Quotes Approved',
    INVOICE_UPLOADED: 'Invoices Sent',
    INVOICE_APPROVED: 'Invoices Paid',
    INITIATED_RESCHEDULE: 'Rescheduling',
    RESCHEDULE_REQUESTED: 'Reschedule Requests',
    CANCELING_INITIATED: 'Cancellation Requests',
};
export function airplaneTicketStatusLabel(status) {
    if (!status)
        return '—';
    switch (status) {
        case 'PENDING':
            return 'Pending Review';
        case 'OFFERED':
            return 'Quote Sent';
        case 'CUSTOMER_APPROVED':
            return 'Customer Approved';
        case 'INVOICE_UPLOADED':
            return 'Invoice Uploaded';
        case 'INVOICE_APPROVED':
            return 'Invoice Approved';
        case 'CALL_CENTER_APPROVED':
            return 'Booking Confirmed';
        case 'CANCELING_INITIATED':
            return 'Cancellation Requested';
        case 'CANCELLED':
            return 'Cancelled';
        default:
            return status.replace(/_/g, ' ');
    }
}
export function formatAirplaneTicketDate(value, withTime = false) {
    return withTime ? formatTableDateTime(value) : formatTableDate(value);
}
export function airplaneTicketTimeRemaining(expiresAt) {
    if (!expiresAt)
        return null;
    const end = new Date(expiresAt).getTime();
    if (Number.isNaN(end))
        return null;
    const diff = end - Date.now();
    if (diff <= 0)
        return 'Expired';
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    if (hours > 24) {
        const days = Math.floor(hours / 24);
        return `${days}d ${hours % 24}h left`;
    }
    return `${hours}h ${mins}m left`;
}
